import React, { useEffect, useState, useCallback } from "react";
import { useParams } from "react-router-dom";
import { adminAPI } from "../../services/api";
import "./Admin.css"; // We'll create one CSS for all admin pages

const AdminDashboard = () => {
  const { eventId } = useParams();
  const [stats, setStats] = useState({
    total_users: 0,
    total_masterclasses: 0,
    total_sessions: 0,
    total_registrations: 0,
    total_events: null,
  });

  const fetchStats = useCallback(async () => {
    try {
      const res = await adminAPI.getStats(eventId);
      setStats(res.data);
    } catch (e) {
      console.error("Error fetching stats", e);
    }
  }, [eventId]);

  useEffect(() => {
    fetchStats();
  }, [fetchStats]);

  return (
    <div className="admin-page">
      <div className="admin-section-header" style={{ marginBottom: "32px" }}>
        <h1 style={{ fontSize: "1.5rem", fontWeight: "700" }}>
          Dashboard {eventId ? `(Event #${eventId})` : "(Global)"}
        </h1>
        <p style={{ color: "var(--admin-text-sub)" }}>
          Welcome to the RF Conference Admin Panel
        </p>
      </div>

      <div className="admin-stats-grid">
        <div className="stat-item">
          <span className="label">Total Users</span>
          <span className="value">{stats.total_users}</span>
        </div>
        <div className="stat-item">
          <span className="label">Masterclasses</span>
          <span className="value">{stats.total_masterclasses}</span>
        </div>
        <div className="stat-item">
          <span className="label">Sessions</span>
          <span className="value">{stats.total_sessions}</span>
        </div>
        <div className="stat-item">
          <span className="label">Registrations</span>
          <span className="value">{stats.total_registrations}</span>
        </div>
        {stats.total_events !== null && (
          <div className="stat-item">
            <span className="label">Total Events</span>
            <span className="value">{stats.total_events}</span>
          </div>
        )}
      </div>

      <div className="admin-card">
        <div className="card-header">
          <h2>Recent Activity</h2>
        </div>
        <div
          style={{
            padding: "24px",
            textAlign: "center",
            color: "var(--admin-text-sub)",
          }}
        >
          No recent activity to display.
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
